module.exports = __webpack_public_path__ + "img/delete-v2.630fc0cd.svg";